import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";          // keep your styles
import App from "./App";
import "./styles/globals.css";
import "./styles/layout.css";
import "./styles/glass.css";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);
